import { renderStatusCell } from 'ui/table/StatusCell';

export const OperationStatusCell = renderStatusCell({
    DONE: 'green',
    PENDING: 'yellow',
    RUNNING: 'yellow',
    ERROR: 'red',
    TIMEOUT: 'red'
});
